// Scope pill: Mine / My teams / All. The ALL chip only renders when the
// viewer is admin / management (server-side guard echoes this).
import { PLANNER_SCOPES, type PlannerScopeId } from "../../../../../../shared/team-planner/const";

export function ScopeSelector({
  value,
  onChange,
  canSeeAllScope,
}: {
  value: PlannerScopeId;
  onChange: (id: PlannerScopeId) => void;
  canSeeAllScope: boolean;
}) {
  const scopes = canSeeAllScope ? PLANNER_SCOPES : PLANNER_SCOPES.filter((s) => s.id !== "all");
  return (
    <div role="radiogroup" aria-label="Scope" className="tp-scope">
      {scopes.map((s) => (
        <button
          key={s.id}
          type="button"
          role="radio"
          aria-checked={s.id === value}
          onClick={() => onChange(s.id)}
          className="tp-scope-btn"
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
